
import View from '../View'
import Text from '../Text'

export default props => <View>Here are some heplful resources</View>

